export default __webpack_public_path__ + "static/media/curshoriz.5725f568.wav";